import { render, staticRenderFns } from "./add-subtask.vue?vue&type=template&id=68127976&scoped=true&"
import script from "./add-subtask.vue?vue&type=script&lang=js&"
export * from "./add-subtask.vue?vue&type=script&lang=js&"
import style0 from "./add-subtask.vue?vue&type=style&index=0&id=68127976&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68127976",
  null
  
)

export default component.exports